import React, {useState, useEffect} from "react";
import {isEmpty} from "lodash";
import {useParams} from "react-router-dom";
import {useDispatch} from "react-redux";
import EmptyGraphMessage from "../../../components/Charts/Containers/EmptyGraphMessage";
import DashboardPage from "../../../views/Dashboard/DashboardPage";
import {
  requestReportAnalysis,
  // requestReportPDF,
} from "../../../redux/Actions/reports.actions";
const ViewReport = () => {
  const dispatch = useDispatch();
  const {reportId} = useParams();
  const [dashboard, setDashboard] = useState({});

  useEffect(() => {
    dispatch(requestReportAnalysis(reportId, setDashboard));
    // dispatch(requestReportPDF(reportId));
  }, [dispatch, reportId]);

  return (
    <div>
      {!isEmpty(dashboard) ? (
        <DashboardPage dashboard={dashboard} isResizable={true} isDraggable={true} />
      ) : (
        <div style={{height: "500px"}}>
          <EmptyGraphMessage message="No data found for this dashboard" />
        </div>
      )}
    </div>
  );
};

export default ViewReport;
